import {
  AdminAnalyticsStats,
  AdminOverviewStats,
  AnalyticsPeriod,
} from "../types/adminStats.definition";
import {
  getAdminAnalyticsStats,
  getAdminOverviewStats,
} from "../webclients/adminStats.client";

/** MED-1330: platform-wide figures for the admin dashboard and analytics pages. */
export const adminStatsApi = {
  getOverview: async (): Promise<AdminOverviewStats> => {
    const response = await getAdminOverviewStats();
    return response.data;
  },

  getAnalytics: async (
    period: AnalyticsPeriod
  ): Promise<AdminAnalyticsStats> => {
    const response = await getAdminAnalyticsStats(period);
    return response.data;
  },
};
